module.exports = __webpack_public_path__ + "static/media/flecha_abajo.7c1730c8.svg";